import React from 'react';
import { FileError, FileRejection } from 'react-dropzone';
import classNames from 'classnames';
import { ImageFileConstraints } from 'types/types';

interface FileConstraintsInfoProps extends ImageFileConstraints {
  rejectedFiles: FileRejection[];
}

export const FileConstraintsInfo = ({
  imageDimensionsConstraint,
  fileSizeConstraint,
  fileTypesConstraint,
  rejectedFiles,
}: FileConstraintsInfoProps) => {
  const containsError = (code: string): boolean => {
    if (rejectedFiles.length == 0) {
      return false;
    }

    return (
      rejectedFiles[0].errors.filter((fileError: FileError) => {
        return fileError.code == code;
      }).length > 0
    );
  };

  return (
    <React.Fragment>
      <p
        className={classNames({
          'profile-creation-content-section-info': true,
        })}
        data-testid="image-dimensions-constraint"
      >
        {imageDimensionsConstraint}
      </p>
      <p
        className={classNames({
          'profile-creation-content-section-info': true,
          'profile-creation-content-section-error': containsError('file-too-large'),
        })}
        data-testid="file-size-constraint"
      >
        {fileSizeConstraint}
      </p>
      <p
        className={classNames({
          'profile-creation-content-section-info': true,
          'profile-creation-content-section-error': containsError('file-invalid-type'),
        })}
        data-testid="file-type-constraint"
      >
        {fileTypesConstraint}
      </p>
    </React.Fragment>
  );
};
